
import { defineComponent } from 'vue';
import UcloudAnnexPolicy from '../../ucloud-annex-policy.vue';

export default defineComponent({
    components: {
        UcloudAnnexPolicy
    }
});
